import {
  REQUEST_LINE_STATUS,
  RequestLineStatus,
} from '@savgroup-front-common/types';

import messages from './messages/sparePartRequestLineStatusMessages';

export const getSparePartRequestLineStatusMessage = (
  requestLineStatus: RequestLineStatus,
) => {
  switch (requestLineStatus) {
    case REQUEST_LINE_STATUS.AVAILABLE_IN_STOCK:
      return messages.AvailableInStock;
    case REQUEST_LINE_STATUS.SUBMITTED_TO_SUPPLIER:
      return messages.SubmittedToSupplier;
    case REQUEST_LINE_STATUS.ORDER_COLLECTED:
      return messages.OrderCollected;
    case REQUEST_LINE_STATUS.REMAINDER:
      return messages.Remainder;
    case REQUEST_LINE_STATUS.SOLD_OUT:
      return messages.SoldOut;
    case REQUEST_LINE_STATUS.TO_PROCESS:
      return messages.ToProcess;
    case REQUEST_LINE_STATUS.TO_VALIDATE:
      return messages.ToValidate;
    case REQUEST_LINE_STATUS.VALID:
      return messages.Valid;
    case REQUEST_LINE_STATUS.CANCELLED:
      return messages.Cancelled;
    case REQUEST_LINE_STATUS.CANCELLED_ABANDONED:
      return messages.CancelledAbandoned;
    case REQUEST_LINE_STATUS.CANCELLED_COMMERCIAL_SOLUTION_EXPIRED:
      return messages.CancelledCommercialSolutionExpired;
    case REQUEST_LINE_STATUS.CANCELLED_COMMERCIAL_SOLUTION_NOT_REPAIRABLE:
      return messages.CancelledCommercialSolutionNotRepairable;
    case REQUEST_LINE_STATUS.CANCELLED_COMMERCIAL_SOLUTION_REMAINDER:
      return messages.CancelledCommercialSolutionRemainder;
    case REQUEST_LINE_STATUS.CANCELLED_COMMERCIAL_SOLUTION_SOLD_OUT:
      return messages.CancelledCommercialSolutionSoldOut;
    case REQUEST_LINE_STATUS.CLOSED:
      return messages.Closed;
    case REQUEST_LINE_STATUS.MISSING:
      return messages.Missing;
    case REQUEST_LINE_STATUS.ORDER_SUBMITTED:
      return messages.OrderSubmitted;
    case REQUEST_LINE_STATUS.ORDER_DELIVERED:
      return messages.OrderDelivered;
    case REQUEST_LINE_STATUS.ORDER_SHIPPED:
      return messages.OrderShipped;
    case REQUEST_LINE_STATUS.REJECTED:
      return messages.Rejected;
    case REQUEST_LINE_STATUS.DISPATCHED:
      return messages.Dispatched;
    case REQUEST_LINE_STATUS.TO_BE_DISPATCHED:
      return messages.ToBeDispatched;
    default:
      return undefined;
  }
};
